export default [{
    path: '/classrooms',
    name: 'classrooms',
    component: () =>
        import ('@/views/pages/classroom/classroom-list/ClassroomList.vue'),
    meta: {
        pageTitle: 'Classrooms',
        breadcrumb: [{
            text: 'Classrooms',
            active: true,
            to:'/classrooms'
        }, ],
        resource: 'classroom',
        action: 'read',
    },
},
{
    path: '/classrooms/view/:id',
    name: 'classrooms-view',
    component: () =>
        import ('@/views/pages/classroom/classroom-view/ClassroomView.vue'),
    meta: {
        pageTitle: 'View classroom',
        breadcrumb: [
        {
            text: 'Classrooms',
            to: '/classrooms'
        },{
            text: 'View',
            active: true,
        },],
        resource: 'classroom',
        action: 'read',
    },
},
{
    path: '/classrooms/edit/:id',
    name: 'classrooms-edit',
    component: () =>
        import ('@/views/pages/classroom/classroom-edit/ClassroomEdit.vue'),
    meta: {
        pageTitle: 'Edit classroom',
        breadcrumb: [
        {
            text: 'Classrooms',
            to: '/classrooms',
        },
        {
            text: 'Edit',
            active: true,
        } ],
        resource: 'classroom',
        action: 'read',
    },
},
{
    path: '/classrooms/add',
    name: 'classrooms-add',
    component: () =>
        import ('@/views/pages/classroom/classroom-add/ClassroomAdd.vue'),
    meta: {
        pageTitle: 'Create classroom',
        breadcrumb: [
        {
            text: 'Classrooms',
            to: '/classrooms',
        },
        {
            text: 'Add',
            active: true,
        }
        ],
        resource: 'classroom',
        action: 'read',
    },
}
]